<template>
  <button class="standart_button" :class="style_type">
    <span>{{text}}</span>
    <div class="icon" v-show="icon != '' && icon != null">
      <svg class="download" xmlns="http://www.w3.org/2000/svg" width="17" height="18" viewBox="0 0 17 18" fill="none">
        <path d="M1.07918 7.33333C1.02701 7.71417 1 8.10372 1 8.5C1 12.9183 4.35786 16.5 8.5 16.5C12.6421 16.5 16 12.9183 16 8.5C16 8.10372 15.973 7.71417 15.9208 7.33333" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
        <path d="M10.5834 7.75C10.1738 8.17141 9.08356 9.83333 8.50004 9.83333M6.41671 7.75C6.82632 8.17141 7.91652 9.83333 8.50004 9.83333M8.50004 9.83333L8.50004 1.5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>
  </button>
</template>

<script>

export default {
  name : "StandartButton",
  props : {
    text : String,
    icon : String,
    style_type: String
  },
  data() {
    return{

    }
  },
  methods: {

  }
}
</script>

<style scoped>
.standart_button {
  outline: none;
  border: none;
  border-radius: 8px;
  background: rgba(27, 120, 188, 0.10);
  height: 49px;
  padding: 12px 12px;
  width: 100%;
  color: var(--Blue, #1B78BC);
  text-align: center;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 123%;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 9px;
  flex: 1;
  text-decoration: none;
  box-sizing: border-box;
}

.standart_button.prime {
  color: var(--White, #FFF);
  background: var(--Blue);
}

.standart_button.danger {
  color: var(--Red, #FA4B61);
  background: rgba(250, 75, 97, 0.08);
}
</style>